import { useTexts } from '../../../../contexts/TextsContext';
import { useData } from '../../../../contexts/DataContext';
import SectionTitle from '../shared/sectionTitle/SectionTitle';
import ServiceCard from './serviceCard/ServiceCard';
import classes from './services.module.scss';

const Services = () => {
    const texts = useTexts();
    const { services } = useData();

    return (
        <section className={classes.Services} id="services" aria-labelledby="services-heading">
            <div className={classes.Inner}>
                <SectionTitle
                    id="services-heading"
                    primaryText={texts.servicesHeadingAccent}
                    secondaryText={texts.servicesHeadingMain}
                />
                <ul className={classes.Grid}>
                    {services.map((service) => (
                        <ServiceCard key={service.id} service={service} />
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Services;
